/* eslint-disable react/forbid-prop-types */
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useRouter } from "next/router";
import { useCurrencyState } from "@hooks/useCurrency";
import { fetchAllVariants } from "../lib/fetch-variants";
import { parseURLParams } from "../lib/url-utils";
import { mergeShopifyAndSanityProducts } from "../lib/merge-shopify-sanity-products";
import { ProductItem } from "./ProductItem";
import { Spinner } from "@components/Spinner";
import styles from "./styles/view.module.css";

const ProductView = ({ product, settings, openReviewsDrawer }) => {
  const sanityProductGroup = product;


  const [currentProduct, setCurrentProduct] = useState(null);
  const [shopifyProductVariants, setShopifyProductVariants] = useState([]);
  const [productGroup, setProductGroup] = useState({});

  const router = useRouter();

  useEffect(() => {
    const getShopifyProductVariants = async () => {
      const availableProducts = sanityProductGroup.shopifyProducts.reduce((acc, shopifyProduct) => {
        if (
          shopifyProduct &&
          shopifyProduct.productReferenceV2 &&
          shopifyProduct.productReferenceV2.store.status === "active"
        ) {
          acc.push(shopifyProduct.productReferenceV2.store.slug.current);
        }
        return acc;
      }, []);

      if (availableProducts.length) {
        const variants = await fetchAllVariants(availableProducts, currency);
        // TODO: fix condition where product is discontinued in shopify but still is not archived in sanity
        setShopifyProductVariants(
          variants.filter((variant) => variant !== null && variant !== undefined)
        );
      }
    };

    // We're changing products
    setCurrentProduct(null);
    setProductGroup({});
    getShopifyProductVariants();
  }, [sanityProductGroup]);

  useEffect(() => {
    const getProductVariantFromUrl = () => {
      if (shopifyProductVariants.length) {
        const { query, selectedProduct } = parseURLParams(
          sanityProductGroup,
          shopifyProductVariants,
          router
        );
        router.replace(
          {
            pathname: "/products/[slug]",
            query,
          },
          undefined,
          { shallow: true }
        );

        setCurrentProduct(selectedProduct);
        setProductGroup(mergeShopifyAndSanityProducts(sanityProductGroup, shopifyProductVariants));
      }
    };

    getProductVariantFromUrl();
  }, [shopifyProductVariants]);

  if (!currentProduct) {
    return (
      <section className={styles.loading}>
        <Spinner />
      </section>
    );
  }

  return (
    <ProductItem
      currentProduct={currentProduct}
      productGroup={productGroup}
      settings={settings}
      setCurrentProduct={setCurrentProduct}
      openReviewsDrawer={openReviewsDrawer}
    />
  );
};

ProductView.propTypes = {
  product: PropTypes.object.isRequired,
  rating: PropTypes.object,
  settings: PropTypes.object,
};

ProductView.defaultProps = {
  rating: null,
  settings: null,
};

export default ProductView;
